export function disableExclusiveModal() {
  const modal = document.getElementById('exclusive-modal');
  if (modal) {
    modal.dataset.disabled = 'true'
    modal.close()
  }
}

export function enableExclusiveModal() {
  const modal = document.getElementById('exclusive-modal');
  if (modal) {
    delete modal.dataset.disabled
  }
}

